import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import logoAsset from "@/assets/flashweb-logo.webp.asset.json";
import { openCookiePreferences } from "@/components/CookieConsent";

export function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-border/50 bg-background/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-2">
            <img
              src={logoAsset.url}
              alt="FlashWeb"
              width="128"
              height="32"
              className="h-8 w-auto brightness-110 contrast-125"
            />
            <span className="font-display text-base font-bold tracking-tight">FlashWeb</span>
          </Link>
          <Link
            to="/"
            className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90"
          >
            Torna al sito
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-14 sm:py-20">
        <p className="text-xs font-semibold uppercase tracking-widest text-primary">Informazioni legali</p>
        <h1 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">Ultimo aggiornamento: {updated}</p>

        <article className="prose prose-invert mt-10 max-w-none prose-headings:font-display prose-headings:tracking-tight prose-h2:mt-10 prose-h2:text-2xl prose-h3:mt-6 prose-h3:text-lg prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary prose-strong:text-foreground">
          {children}
        </article>
      </main>

      <LegalFooter />
    </div>
  );
}

export function LegalFooter() {
  return (
    <footer className="border-t border-border/50 bg-card/30">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-6 py-10 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-semibold text-foreground">FlashWeb Agency</p>
          <p className="mt-1">
            Un brand di <span className="text-foreground">FVT FuturaVision Technology GmbH</span> — Zug, Svizzera
          </p>
          <p className="mt-1">
            <a href="mailto:info@flash-web.ch" className="hover:text-foreground">
              info@flash-web.ch
            </a>
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          <Link to="/privacy-policy" className="hover:text-foreground">Privacy Policy</Link>
          <Link to="/cookie-policy" className="hover:text-foreground">Cookie Policy</Link>
          <Link to="/termini-condizioni" className="hover:text-foreground">Termini</Link>
          <Link to="/impressum" className="hover:text-foreground">Impressum</Link>
          <button
            type="button"
            onClick={() => openCookiePreferences()}
            className="text-left hover:text-foreground"
          >
            Preferenze cookie
          </button>
        </nav>
      </div>
    </footer>
  );
}
